document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-image-url');
      if (mainImage && url) { mainImage.setAttribute('src', url); }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Bundle picker (variant radios) ---------- */
  var bundleForm = document.getElementById('ProductForm');
  if (bundleForm) {
    var radios = bundleForm.querySelectorAll('input[name="bundle-variant"]');
    var variantIdField = document.getElementById('ProductVariantId');
    var ctaPrice = bundleForm.querySelector('[data-cta-price]');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var option = radio.closest('.bundle-option');
        document.querySelectorAll('.bundle-option').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        if (option) { option.classList.add('is-selected'); }

        if (variantIdField) { variantIdField.value = radio.value; }

        var priceEl = option ? option.querySelector('.bundle-option__price') : null;
        if (priceEl && ctaPrice) { ctaPrice.textContent = priceEl.textContent.trim(); }
      });
    });
  }

  /* ---------- Quantity steppers (product form) ---------- */
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('.qty-stepper__input');
    var decrease = stepper.querySelector('[data-qty-decrease]');
    var increase = stepper.querySelector('[data-qty-increase]');
    if (!input) { return; }

    if (decrease) {
      decrease.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10);
        if (isNaN(min)) { min = 1; }
        input.value = Math.max(min, val - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (increase) {
      increase.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  /* ---------- Cart page: qty change auto-submits update form ---------- */
  var cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    cartForm.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var updateBtn = cartForm.querySelector('button[name="update"]');
        if (updateBtn) { updateBtn.click(); }
      });
    });
  }

  /* ---------- FAQ / accordion: only one open at a time within same group (optional) ---------- */
  document.querySelectorAll('.accordion-group').forEach(function (group) {
    var items = group.querySelectorAll('details.accordion');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) { other.open = false; }
          });
        }
      });
    });
  });
});
